import { environment as defaultEnvironment } from "./environment.default";

export const environment = {
  ...defaultEnvironment,
  production: true,
  fullUrl: "https://audio.technomad.fr",
  apiUrl: "https://api-audio.technomad.fr",
};
